module.exports = __webpack_public_path__ + "img/logo_menu.d3aa1f55.png";